import React from 'react';
import { Cases } from '../components/Cases';
import { Contact } from '../components/Contact';
import { PageHeader } from '../components/PageHeader';

export const CasesPage: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <PageHeader 
        title="Success//Stories" 
        subtitle="Ergebnisse" 
      />
      <div className="bg-[#111111]">
        <Cases />
      </div>
      <Contact />
    </div>
  );
};